
import { useMutation, useQueryClient } from "react-query"
import { useSetRecoilState } from "recoil";
import { error_message, success_message } from "../../../global_state";
import { approve_job_seeker } from "../../../services/approvals";


const useApproveJS = (notes) => {
    const set_success = useSetRecoilState(success_message)
    const set_error = useSetRecoilState(error_message)
    const queryClient = useQueryClient()
    return useMutation( (id)=>approve_job_seeker(id, notes), {
        onSuccess: data => {
            queryClient.invalidateQueries('get_job_seekers')
            set_success('Profile approved')
            setTimeout(() => {
                set_success('')
              }, 5000);
        },
        onError: () => {
            set_error('Problem Approving Candidate!')
            setTimeout(() => {
              set_error('')
            }, 4000);
          }
    })
}

export default useApproveJS;